import { Link as RouterLink } from 'react-router-dom';
import Logo from './Logo';

export default function Header() {
  return (
    <>
      <header className="fixed inset-x-0 top-0 z-[1201] w-full bg-surface">
        <div className="mx-auto max-w-[1536px] px-4 min-[600px]:px-6">
          <div className="flex min-h-14 items-center py-5 min-[600px]:min-h-16">
            <RouterLink to="/" className="flex grow items-center no-underline">
              <div className="flex items-center">
                <Logo />
              </div>
            </RouterLink>
          </div>
        </div>
      </header>

      {/* Spacer for the fixed header */}
      <div className="h-20 min-[900px]:h-24" />
    </>
  );
}
